var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import { Route } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import ProductOptions from '../SelfServe/ProductOptions/ProductOptions';
import SignupTeam from '../SelfServe/SignupTeam/SignupTeam';
export var selfServeRoutes = {
    PRODUCT_OPTIONS_PATH: PORTAL_ROUTE_PREFIX + "/product-options",
    SIGN_UP_TEAM_ROUTE: PORTAL_ROUTE_PREFIX + "/sign-up-team",
};
export var PUBLIC_ROUTES = [
    selfServeRoutes.PRODUCT_OPTIONS_PATH,
    selfServeRoutes.SIGN_UP_TEAM_ROUTE,
];
export var PUBLIC_ROUTES_COMPONENTS = [
    React.createElement(Route, { path: selfServeRoutes.PRODUCT_OPTIONS_PATH, exact: true, component: ProductOptions }),
    React.createElement(Route, { path: selfServeRoutes.SIGN_UP_TEAM_ROUTE, exact: true, component: SignupTeam }),
];
/**
 * In a perfect world, we will just map over the PUBLIC_ROUTES together with some kind of config to get a list of <Route /> components
 *
 * PUBLIC_ROUTES = [{route: PRODUCT_OPTIONS_PATH, exact: true, component: () => <h1>yolo</h1>}].map((props) => <Route {...props} />)
 *
 * BUT React Router and its typescript definitions are messing thing up a bit, it does not compile
 * So falling back to this list of component and do some basic check
 */
export var getPublicRouteComponent = function () {
    var setOfPublicRoutes = new Set(__spread(PUBLIC_ROUTES));
    var allRouteComponentsPaths = [];
    React.Children.forEach(PUBLIC_ROUTES_COMPONENTS, function (element) {
        allRouteComponentsPaths.push(element.props.path || '');
    });
    var setOfPublicRoutesComponentsRoutes = new Set(__spread(allRouteComponentsPaths));
    if (PUBLIC_ROUTES_COMPONENTS.length !== PUBLIC_ROUTES.length ||
        setOfPublicRoutes.size !== PUBLIC_ROUTES_COMPONENTS.length ||
        setOfPublicRoutes.size !== setOfPublicRoutesComponentsRoutes.size ||
        !Array.from(setOfPublicRoutes).every(function (publicRoute) {
            return setOfPublicRoutesComponentsRoutes.has(publicRoute);
        })) {
        throw new Error('Not all public routes are mapped to Route components');
    }
    return PUBLIC_ROUTES_COMPONENTS;
};
